import { RcSuspense } from '@/components/atoms/RcSuspense'
import { RcIconButton } from '@/components/molecules/interactive/RcIconButton'
import { useChatRoomDocument } from '@/entity/chat/useChatRoomDocument'
import Stack from '@mui/material/Stack'
import { EntityType } from '@rallycry/api-suite-typescript/dist/models/EntityType'
import { useState } from 'react'
import { ChatInfo } from './ChatInfo'
import { ChatRoomContent } from './ChatRoomContent'
import { ChatRoomHeader } from './ChatRoomHeader'
import {
  CommunityTicketHeader,
  CompetitionTicketHeader
} from './ChatRoomTickets'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'

export interface ChatRoomProps {
  chatId?: string
  onNavigate?: () => void
  onLeave?: () => void
  onToggle?: () => void
  showInfo?: boolean
  autoFocusInput?: boolean
  action?: React.ReactNode
  focused?: boolean
}

export const ChatRoom = (props: ChatRoomProps) => {
  const [open, setOpen] = useState(false)
  const { focused, chatId } = props
  const {
    room,
    attributes: { childId, childType }
  } = useChatRoomDocument({
    idOrKey: chatId
  })

  return (
    <Stack
      direction='column'
      width={'100%'}
      height={'100%'}
      position={'relative'}
      overflow={'hidden'}
    >
      <ChatRoomHeader
        {...props}
        action={
          props.showInfo ? (
            <ClickAwayListener onClickAway={() => setOpen(false)}>
              <Box>
                <RcIconButton
                  icon={['fal', 'info-circle']}
                  onClick={() => setOpen(o => !o)}
                />
                <Box
                  component={Paper}
                  elevation={4}
                  sx={theme => ({
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    p: 4,
                    zIndex: theme.zIndex.modal,
                    height: '100%',
                    width: 300,
                    boxShadow: 3,
                    borderRadius: 1,
                    transform: open ? 'translateX(0)' : 'translateX(100%)',
                    transition: 'transform 300ms ease-in-out'
                  })}
                >
                  <ChatInfo room={room} onClose={() => setOpen(false)} />
                </Box>
              </Box>
            </ClickAwayListener>
          ) : (
            props.action
          )
        }
      />
      {focused ? (
        <RcSuspense>
          {childType === EntityType.COMMUNITY_TICKET ? (
            <CommunityTicketHeader
              key={room?.archived ? 'active' : 'archived'}
              ticketId={childId}
            />
          ) : childType === EntityType.COMPETITION_TICKET ? (
            <CompetitionTicketHeader
              key={room?.archived ? 'active' : 'archived'}
              ticketId={childId}
            />
          ) : null}

          <ChatRoomContent {...props} />
        </RcSuspense>
      ) : null}
    </Stack>
  )
}

// t('shared.new-messages', { count })
// t('shared.new-messages', { count })
